import { render, staticRenderFns } from "./SMSDashboard.vue?vue&type=template&id=379bd30d"
import script from "./SMSDashboard.vue?vue&type=script&lang=js"
export * from "./SMSDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports